import update from 'immutability-helper';
import * as types from './types';

export const ChartsTabKey = 'charts';
export const AdContentTabKey = 'adContent';
export const BenchmarkTabKey = 'benchmarkKPI';

const initialState = {
  activeTab: ChartsTabKey,
};

const switchMap = {};

switchMap[types.INIT] = state => update(state, {
  $set: initialState,
});

switchMap[types.SET_ACTIVE_TAB] = (state, action) => {
  const { tabKey } = action;
  return update(state, {
    activeTab: { $set : tabKey}
  });
}

export default (state = initialState, action) => (switchMap[action.type]
  ? switchMap[action.type](state, action) : state);
